"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lunr_1 = __importDefault(require("lunr"));
function createSearch(index, indexEntries) {
    return function search(query) {
        query = query.toLowerCase(); // REVIEW: wouldn't be better in searchPipeline?
        const result = index.query(q => {
            // prefix search, no boost
            q.term(query, { wildcard: lunr_1.default.Query.wildcard.TRAILING, boost: 1, usePipeline: false });
            // 'exact' match, boosted
            q.term(query, { boost: 10, usePipeline: true });
        });
        return buildSearchResult(result, indexEntries);
    };
}
exports.createSearch = createSearch;
function buildSearchResult(lunrResult, indexEntries) {
    const items = [];
    for (let item of lunrResult) {
        const id = item.ref;
        const score = item.score; // can be used for ordering
        const metadata = item.matchData.metadata;
        const indexEntry = indexEntries.find((x) => x.id === id);
        let resultItem = items.find(x => x.id === id);
        if (!resultItem) {
            resultItem = { id, score: score, fields: {} };
            items.push(resultItem);
        }
        for (let term in metadata) {
            const termMeta = metadata[term];
            for (let field in termMeta) {
                let positions = (termMeta[field]).position;
                let coordinatePositions = positions.map(x => ({
                    start: x[0],
                    end: x[0] + x[1]
                }));
                let uniquePositions = [];
                coordinatePositions.forEach((item) => {
                    if (uniquePositions.findIndex(x => arePositionsEqual(x, item)) < 0) {
                        uniquePositions.push(item);
                    }
                });
                const existingItem = resultItem.fields[field];
                if (existingItem) {
                    const mergedPositions = [...existingItem.positions];
                    for (let newPosition of uniquePositions) {
                        const hasOverlap = mergedPositions.findIndex(x => hasPositionOverlap(newPosition, x)) >= 0;
                        if (!hasOverlap) {
                            mergedPositions.push(newPosition);
                        }
                    }
                    uniquePositions = mergedPositions;
                }
                resultItem.fields[field] = {
                    value: indexEntry[field],
                    positions: uniquePositions
                };
            }
        }
    }
    return items;
    function arePositionsEqual(a, b) {
        return a.start === b.start && a.end === b.end;
    }
    function hasPositionOverlap(a, b) {
        return (a.start >= b.start && a.start <= b.end || b.start >= a.start && b.start <= a.end);
    }
}
//# sourceMappingURL=lunr-search.js.map